import { __assign } from "tslib";
import * as React from 'react';
import { st, classes } from './DropdownOption.st.css';
export var DropdownOption = function (props) {
    var id = props.id, option = props.option, isSelected = props.isSelected, isHovered = props.isHovered, onClickHandler = props.onClickHandler, onMouseEnterHandler = props.onMouseEnterHandler, onMouseLeaveHandler = props.onMouseLeaveHandler, dataHook = props.dataHook;
    var disabled = option.isDisabled;
    var selectable = option.isSelectable;
    var hovered = !disabled && isHovered;
    var selected = !disabled && isSelected;
    var ariaProps = selectable
        ? { role: 'menuitem', 'aria-selected': selected, 'aria-disabled': disabled }
        : {};
    return (React.createElement("div", __assign({ id: id, tabIndex: -1, className: st(classes.root, { disabled: disabled, selectable: selectable, hovered: hovered, selected: selected }, props.className), "data-hook": dataHook }, ariaProps, { onClick: onClickHandler, title: option.value, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler }), option.render(option.value)));
};
DropdownOption.displayName = 'DropdownOption';
//# sourceMappingURL=DropdownOption.js.map